
import React from 'react';
import { Button } from '@/components/ui/button';

const DialogFooter: React.FC = () => {
  return (
    <div className="border-t p-4 flex justify-between items-center">
      <Button 
        variant="destructive" 
        className="text-red-500 bg-white border border-red-300 hover:bg-red-50"
      >
        Supprimer la publication
      </Button>
      
      <div className="flex items-center gap-2">
        <Button variant="outline" className="text-gray-700">
          Actions sur la publication
        </Button>
        <Button className="bg-blue-600 hover:bg-blue-700">
          Afficher dans la boîte de réception
        </Button>
      </div>
    </div>
  );
};

export default DialogFooter;
